/* eslint-disable no-console */
import {loggerDispatch} from "../../context/AppStateProvider";
import * as util from "util";
export class Logger {
  constructor(private name: string) {}

  private addMessage(message: string, level: string, params: unknown[]) {
    if (loggerDispatch) {
      const action = {
        level: level,
        message: util.format(message, ...params),
        module: this.name,
        type: "Append" as const
      };

      // Note: setTimeout(..., 0) moves the logger context update out of the current render call stack.
      // Getting a lot of console warnings: Cannot update a component (LoggerContext) while rendering a different component
      setTimeout(() => {
        loggerDispatch?.(action);
      }, 0);
    }
  }

  info(message: string, ...params: unknown[]) {
    this.addMessage(message, "Info", params);
    console.info(this.prefix(message), ...params);
  }

  error(message: string, ...params: unknown[]) {
    this.addMessage(message, "Error", params);
    console.error(this.prefix(message), ...params);
  }

  warn(message: string, ...params: unknown[]) {
    this.addMessage(message, "Warning", params);
    console.warn(this.prefix(message), ...params);
  }

  exception(message: string, ...params: unknown[]) {
    this.addMessage(message, "Exception", params);
    console.error(this.prefix(message), ...params);
  }

  private prefix(message: string) {
    return `${new Date().toLocaleString()}: ${this.name}: ${message}`;
  }
}
